let opener: HTMLElement | null = null;

export function openDialog(dialog: HTMLDialogElement, openedBy?: HTMLElement): void {
  opener = openedBy ?? document.activeElement as HTMLElement | null;
  dialog.addEventListener("keydown", trapFocus);
  dialog.addEventListener("close", restoreFocus, { once: true });
  dialog.showModal();
  focusable(dialog)[0]?.focus();
}

export function closeDialog(dialog: HTMLDialogElement): void {
  dialog.close();
}

function trapFocus(event: KeyboardEvent): void {
  if (event.key === "Escape") return;
  if (event.key !== "Tab") return;
  const dialog = event.currentTarget as HTMLDialogElement;
  const items = focusable(dialog);
  if (items.length === 0) {
    event.preventDefault();
    return;
  }
  const first = items[0]!;
  const last = items.at(-1)!;
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

function restoreFocus(event: Event): void {
  const dialog = event.currentTarget as HTMLDialogElement;
  dialog.removeEventListener("keydown", trapFocus);
  if (opener?.isConnected) opener.focus();
  opener = null;
}

function focusable(root: HTMLElement): HTMLElement[] {
  return [...root.querySelectorAll<HTMLElement>(
    "button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex='-1'])",
  )].filter((node) => !node.hidden);
}
